module.exports = __webpack_public_path__ + "static/img/20140211-20141111.b75810d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/20140211-20141111.png
// module id = z8yG
// module chunks = 1